import $ from 'jquery'
import Cookies from 'js-cookie';

export default function popupDirective(context = document.body) {
   const $element = $(context).find('[sw-popup]');

   $element.each(function () {
      const $this = $(this);
      const timer = $this.attr('sw-popup')/1;
      
      const button = $this.find('.popup_close');

      function setupTimer() {
         setTimeout(function(){
            $this.removeClass('is-closed');
         }, timer*1000);
      }

      $(button).click(function(e){
         $this.addClass('is-closed');
         
         Cookies.set('popup-start', Date.now());

         setupTimer();
      });

      if(Cookies.get('popup-start')) {
         // console.log('checking');
         const startTime = Cookies.get('popup-start');
         const predictedEndTime = startTime/1 + (timer * 1000);
         const currentTime = Date.now();
         // console.log(predictedEndTime);
         // console.log(currentTime);
         if(predictedEndTime > currentTime) {
            // console.log('predicted');
            setTimeout(function(){
               $this.removeClass('is-closed');
               Cookies.remove('popup-start');
            }, (predictedEndTime - currentTime));
         } else {
            // console.log('predicted else');
            Cookies.remove('popup-start');
            $this.removeClass('is-closed');
         }
      } else {
         // console.log('else');
         setTimeout(function(){
            $this.removeClass('is-closed');
         }, 6000);
      }
   });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/popup.js